// Module
var code = " <gh-dialog layout=\"catalog\"> <gh-dialog-header title=\"{{'lbl_zoom' | translate}}\"></gh-dialog-header> <gh-dialog-content> <div class=\"zoom\"> <canvas #zoomCanvas=\"\" class=\"zoom-canvas\" (contextmenu)=\"false\" (mousemove)=\"updateCursor($event)\" (click)=\"onClick($event)\"></canvas> </div> </gh-dialog-content> </gh-dialog> ";
// Exports
module.exports = code;